import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { BoardTheme, BoardThemeResponse } from '../../models/inModels/BoardTheme';

@Injectable()
export class BoardThemeService {
	private route = '/api/board/theme';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/search`, event, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<BoardThemeResponse> {
		return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as BoardThemeResponse)
			.catch(error => this.logging.handleError(error));
	}

	create(coupon: BoardTheme): Promise<BoardThemeResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create`, coupon, { headers: this.auth.header })
			.toPromise()
			.then(response => response as BoardThemeResponse)
			.catch(error => this.logging.handleError(error));
	}

	update(coupon: BoardTheme): Promise<BoardThemeResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/update`, coupon, { headers: this.auth.header })
			.toPromise()
			.then(response => response as BoardThemeResponse)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: string): Promise<any> {
		return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/board-themes/board-themes.service.ts